import Stack from "@mui/material/Stack";
import React, { useMemo } from "react";

type DetailsContainerProps = { data: any; processItem: any };

const DetailsTreeContainer: React.FC<DetailsContainerProps> = ({ data, processItem }) => {
	const processedData = useMemo(() => {
		if (Array.isArray(data)) {
			return data.map((dataItem, index: number) => {
				if(Object.keys(dataItem).length === 0) return null;
				return (
					<Stack
						key={index}
						borderBottom={data.length - 1 !== index ? "1px solid #E8E8E8" : "none"}
						py={2}
						gap={3}
					>
						{processItem(dataItem)}
					</Stack>
				);
			});
		}
	}, [data]);

	return <>{processedData}</>;
};

export default DetailsTreeContainer;
